import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

export default function MaintenanceBanner() {
  return (
    <div className="maintenance-banner" role="status">
      <div className="container">
        <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
        <strong>Planned website maintenance:</strong> Due to scheduled website
        maintenance between 10.30pm Monday 28 September and 4.30am, Tuesday 29
        September, bookings will be unavailable. Thank you for your
        understanding.
      </div>
    </div>
  );
}
